import type { CentrifugeMessage } from '../messageTypes';
import type { LangCode } from './normalChatMessageTypes';

export type CaptionMessage = {
  data: {
    createAt: number;
    type: 'caption';
    message: {
      lang: LangCode;
      text: string;
    }[];
  };
  offset: number;
};

export const isCaptionMessage = (obj: string | object | CaptionMessage | unknown): obj is CaptionMessage => {
  if (typeof obj !== 'object' || obj === null) return false;
  const payload = obj as CaptionMessage;
  if (!payload.data || typeof payload.data.createAt !== 'number') return false;
  if (!Array.isArray(payload.data.message)) return false;
  for (const caption of payload.data.message) {
    if (typeof caption !== 'object' || caption === null) return false;
    if (caption.lang !== 'ko' && caption.lang !== 'ja') return false;
    if (typeof caption.text !== 'string') return false;
  }

  return true;
};

export interface CorrectCaptionMessage {
  data: {
    type: 'correctCaption';
    message: {
      after: string;
      before: string;
    };
  };
  offset: number;
}

export const isCorrectCaptionMessage = (item: CentrifugeMessage): item is CorrectCaptionMessage => {
  return 'data' in item && item.data.type === 'correctCaption';
};
